import React, {useEffect, useState} from 'react';
import {AnimatePresence, motion} from 'framer-motion';

import state from '../../../store';
import {EditorTabs, FilterTabs, DecalTypes} from '../config/constants';
import {slideAnimation} from '../config/motion';
import {ColorPicker, Tab} from '../components';

interface ActiveFilterTab {
    logoShirt: boolean;
    stylishShirt: boolean;
}

const Customizer: React.FC = () => {
    const [activeEditorTab, setActiveEditorTab] = useState<string>('');
    const [activeFilterTab, setActiveFilterTab] = useState<ActiveFilterTab>({
        logoShirt: true,
        stylishShirt: false,
    });

    const generateTabContent = () => {
        switch (activeEditorTab) {
            case 'colorpicker':
                return <ColorPicker onClose={() => setActiveEditorTab('')} />;
            default:
                return null;
        }
    };

    const handleDecals = (type: string, result: string) => {
        const decalType = DecalTypes[type];

        if (!decalType) {
            console.error(`Invalid decal type: ${type}`);
            return;
        }
        state.logoDecal = result;
        state.fullDecal = result;

        if (!activeFilterTab[decalType.filterTab as keyof ActiveFilterTab]) {
            handleActiveFilterTab(decalType.filterTab);
        }
    };

    const handleActiveFilterTab = (tabName: string) => {
        switch (tabName) {
            case 'logoShirt':
                state.isLogoTexture = !activeFilterTab.logoShirt;
                break;
            case 'stylishShirt':
                state.isFullTexture = !activeFilterTab.stylishShirt;
                break;
            default:
                state.isLogoTexture = true;
                state.isFullTexture = false;
                break;
        }

        setActiveFilterTab((prevState) => ({
            ...prevState,
            [tabName]: !prevState[tabName as keyof ActiveFilterTab],
        }));
    };

    useEffect(() => {
        if (state.imageBase64) {
            handleDecals('logo', state.imageBase64);
            setActiveEditorTab('');
        }
    }, []);

    return (
        <AnimatePresence>
            <>
                <motion.div className='filtertabs-container' {...slideAnimation('up')}>
                    {FilterTabs.map((tab) => (
                        <Tab
                            key={tab.name}
                            tab={tab}
                            isFilterTab
                            isActiveTab={activeFilterTab[tab.name as keyof ActiveFilterTab]}
                            handleClick={() => handleActiveFilterTab(tab.name)}
                        />
                    ))}
                    <div className='editortabs-container'>
                        {EditorTabs.map((tab) => (
                            <Tab key={tab.name} tab={tab} handleClick={() => setActiveEditorTab(tab.name)} />
                        ))}

                        {generateTabContent()}
                    </div>
                </motion.div>
            </>
        </AnimatePresence>
    );
};

export default Customizer;
